import React, { lazy } from 'react';
import HomeLayout from '../../layouts/HomeLayout';
import RouterRender from '../routerRender';
import R from './Router';
import FormPersonalNew from '../../pages/DSA-NDADComponent/User/PersonalDataAgreementComponent/FormPersonal';
import FormPersonal from '../../pages/DSA-NDADComponent/User/FormPersonal/MainFormPersonaNew';
import IndexDetailPessonalAgree from '../../pages/DSA-NDADComponent/User/PersonalDataAgreementComponent/IndexDetailPessonalAgree';
import MainAdminPage from '../../pages/DSA-NDADComponent/User/PendingDocument/MainAdminPage';
import MainProvincialPublicHealth from '../../pages/DSA-NDADComponent/User/PendingDocument/MainProvincialPublicHealth';


const Digitalcertificates = lazy(() => import('../../pages/DSA-NDADComponent/User/Digitalcertificates/Certificates'));
const DigitalMedicalCert = lazy(() => import('../../pages/DSA-NDADComponent/User/Digitalcertificates/DigitalMedicalCertificates'));
const Signature = lazy(() => import('../../pages/DSA-NDADComponent/User/SignatureComponent/MainSignature'));
const DocumentPersonal = lazy(() => import('../../pages/DSA-NDADComponent/User/PersonalDataAgreementComponent/MainDetailPersonal'));
const SelectPersonalData = lazy(() => import('../../pages/DSA-NDADComponent/User/PersonalDataAgreementComponent/MainPersonDataType'));
const IndexDocumentPer = lazy(() => import('../../pages/DSA-NDADComponent/User/DocumentPersonalComponent/MainDocumentPersonal'));
const GuestDocument = lazy(() => import('../../pages/DSA-NDADComponent/Guest/DocumentPersonalComponent/MainDocumentGuest'));
const SharedToken = lazy(() => import('../../pages/LoginComponent/SharedToken'));
const MainPendingDocument = lazy(() => import('../../pages/DSA-NDADComponent/User/PendingDocument/HeaderPendingDocument'));
const IndexDocumentPending = lazy(() => import('../../pages/DSA-NDADComponent/User/PendingDocument/MainDocumentPersonalPending'));
const MainDetailPending = lazy(() => import('../../pages/DSA-NDADComponent/User/PendingDocument/DetailDocPending'));
const D = lazy(() => import('../../pages/DSA-NDADComponent/User/PendingDocument/MainDocumentPersonalPending'));
const DetailPersonalAgree = lazy(() => import('../../pages/DSA-NDADComponent/User/PersonalDataAgreementComponent/DetailPersonalAgree'));
const MainError = lazy(() => import('../../pages/DSA-NDADComponent/User/ErrorComponent/PageNotFound'));
const PageNotFound = lazy(() => import('../../pages/DSA-NDADComponent/User/ErrorComponent/PageNotFound'));

const Router = (): any => {
  const userRole = sessionStorage.getItem("UserRole"); // ดึงบทบาทจาก localStorage

  return [
    RouterRender([
      {
        link: R.Digitalcertificates.link,
        layout: HomeLayout,
        component: Digitalcertificates,
      },
      {
        link: R.DigitalMedicalCert.link,
        layout: HomeLayout,
        component: DigitalMedicalCert,
      },
      {
        link: R.Signature.link,
        layout: HomeLayout,
        component: Signature,
      },
      {
        link: R.PageAdminDoc.link,
        layout: HomeLayout,
        component: MainAdminPage,
      },
      {
        link: R.PagePublicHealth.link,
        layout: HomeLayout,
        component: MainProvincialPublicHealth,
      },
      
      {
        link: R.DocumentPersonal.link,
        layout: HomeLayout,
        component: DocumentPersonal,
      },

      {
        link: R.SelectPersonalData.link,
        layout: HomeLayout,
        component: SelectPersonalData,
      },
      {
        link: R.IndexDocumentPer.link,
        layout: HomeLayout,
        component: IndexDocumentPer,
      },
      {
        link: R.FormPersonal.link,
        layout: HomeLayout,
        component: FormPersonal,
      },
      {
        link: R.FormPersonalNew.link,
        layout: HomeLayout,
        component: FormPersonalNew,
      },
      {
        link: R.GuestDocument.link,
        layout: React.Fragment,
        component: GuestDocument,
      },
      {
        link: R.SharedToken.link,
        layout: React.Fragment,
        component: SharedToken,
      },
      {
        link: R.MainPendingDocument.link,
        layout: HomeLayout,
        component: MainPendingDocument,
      },
      {
        link: R.IndexDocumentPending.link,
        layout: HomeLayout,
        component: IndexDocumentPending,
      },
      {
        link: R.DetailPersonalAgree.link,
        layout: HomeLayout,
        component: IndexDetailPessonalAgree,
      },
      // {
      //   link: R.MainDetailPending.link,
      //   layout: React.Fragment,
      //   component: MainDetailPending,
      // },
      {
        link: R.MainError.link,
        layout: React.Fragment,
        component: MainError,
      },
      {
        link: R.PageNotfound.link,
        layout: React.Fragment,
        component: PageNotFound,
      },
      
      
    
      
      
    ]),
  ].map((router: any) => router);
};

export default Router();
